import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { PurchaseOrderDetailsView } from "@surgia/ui";
import { permissions } from "../../permissions";
import { HUB_PROTECTED_ROUTES } from "../../routes";

// Import the modal
import PurchaseRequestDetailsModal from "../../containers/Modals/PurchaseRequestDetailsModal";

function HubPurchaseOrderDetailsView() {
  const navigate = useNavigate();
  const { id: purchaseOrderId } = useParams();
  const authState = useSelector((state: RootState) => state.auth);

  // Add user permissions selector
  const userPermissions = useSelector(
    (state: RootState) =>
      state.auth.globalState.user_permissions?.map(
        (permission) => permission.name
      ) || []
  );

  const breadcrumbItems = [
    {
      label: "Purchase Requests",
      onClick: () => navigate(HUB_PROTECTED_ROUTES.PURCHASE_REQUESTS),
      show: true,
    },
    {
      label: "View purchase order",
      show: true,
    },
  ];

  return (
    <PurchaseOrderDetailsView
      tenantId={authState.globalState.tenant_id?.toString() || ""}
      purchaseOrderId={purchaseOrderId || ""}
      componentId={import.meta.env.VITE_PUBLIC_COMPONENT_ID || ""}
      breadcrumbItems={breadcrumbItems}
      userPermissions={userPermissions}
      canViewPurchaseRequests={true}
      isSuperAdmin={false}
      PurchaseRequestDetailsModal={PurchaseRequestDetailsModal}
      showSkeletonLoading={true}
      VIEW_PURCHASE_REQUEST_PERMISSION={permissions.VIEW_PURCHASE_REQUEST}
    />
  );
}

export default HubPurchaseOrderDetailsView;
